import { ComponentUtil } from '../../utils/ComponentUtil';
import { Hooks } from '../../types/Hooks';

ComponentUtil.loader(
  !!document.querySelector(Hooks.FooterAccordion),
  () => import('./FooterAccordion'),
  (FooterAccordion) => {
    ComponentUtil.binder(Hooks.FooterAccordion, FooterAccordion);
  },
);
